import Swiper from "../../../vendors/swiper.min";
import { findClosestElementByClass } from "../helpers/dom/closest";
import insertAfter from "../helpers/dom/insertAfter";

export const infoTab = {
	initTabs: function() {
		const modul = document.querySelectorAll("[data-info-tab]");
		const tabs = document.querySelectorAll(".info-tab__tab");

		let tabsSwiper = [];

		[].forEach.call(modul, el => {
			const tabContent = el.querySelectorAll(".info-tab__content");
			const contents = el.querySelector(".info-tab__contents");

			[].forEach.call(tabContent, tCont => {
				contents.appendChild(tCont);
			});

			const swContainer = el.querySelector(".swiper-container");
			const slides = swContainer.querySelectorAll(".swiper-slide");
			if (slides.length < 4)
				swContainer.querySelector(".swiper-wrapper").classList.add("center-slides");

			tabsSwiper.push(
				new Swiper(swContainer, {
					slidesPerView: 4,
					touchRatio: 1,
					a11y: {
						prevSlideMessage: swContainer.querySelector(".swiper-wrapper").getAttribute("prev-slide-aria-label"),
						nextSlideMessage: swContainer.querySelector(".swiper-wrapper").getAttribute("next-slide-aria-label"),
					},
					keyboard: true,
					navigation: {
						nextEl: ".swiper-button-next",
						prevEl: ".swiper-button-prev"
					},
					breakpoints: {
						599: {
							slidesPerView: 1
						}
					}
				})
			);
		});

		tabs.forEach(t => {
			t.addEventListener("click", infoTab.displayContent);
			t.addEventListener("keydown", e => {
				if (e.keyCode === 13 || e.keyCode === 32) {
					infoTab.displayContent(e);
				}
			});
		});
	},

	displayContent: function(e) {
		e.preventDefault();
		let target = e.target.classList.contains("info-tab__tab")
			? e.target
			: findClosestElementByClass(e.target, "info-tab__tab");
		let contentId = target.getAttribute("data-content");
		const container = findClosestElementByClass(target, "info-tab");
		container.querySelectorAll(".info-tab__content").forEach(content => {
			content.style.display = "none";
		});

		const activeContent = document.getElementById(`${contentId}`);
		activeContent.style.display = "block";
		infoTab.setActiveTab(container, target);
		infoTab.animateContainer(activeContent);
		infoTab.addContentPosition(target, container);
	},

	setActiveTab: function(container, active) {
		container.querySelectorAll(".info-tab__tab").forEach(tab => {
			tab.classList.remove("active");
			tab.setAttribute('aria-selected', 'false');
		});
		active.classList.add("active");
		active.setAttribute('aria-selected', 'true');
	},

	animateContainer: function(activeTab) {
		// const container = findClosestElementByClass(activeTab, 'info-tab__contents');
		// setTimeout(function () {
		// container.style.height = activeTab.offsetHeight + "px";
		// }, 100);
	},

	addContentPosition: function(activeTab, container) {
		const content = container.querySelector(".info-tab__contents");

		if (window.innerWidth > 599) {
			const desktopContainer = container.querySelector(".info-tab__desktop");
			desktopContainer.appendChild(content);
		} else {
			insertAfter(content, activeTab);
		}
	},

	setActiveTabInitPositions: function() {
		const tabs = document.querySelectorAll(".info-tab");
		tabs.forEach(tabContainer => {
			const content = tabContainer.querySelector(".info-tab__contents");

			if (window.innerWidth > 599) {
				const desktopContainer = tabContainer.querySelector(".info-tab__desktop");
				desktopContainer.appendChild(content);
			} else {
				const activeTab = tabContainer.querySelector(".info-tab__tab.active");
				insertAfter(content, activeTab);
			}
		});
	}
};
